"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.sizes = exports.contentCss = exports.innerWrapperCss = exports.innerCss = exports.Overlay = exports.wrapperCss = void 0;

var _styledBase = _interopRequireDefault(require("@emotion/styled-base"));

var _core = require("@emotion/core");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var wrapperCss = {
  name: "izz3zf-wrapperCss",
  styles: "width:100%;height:100%;position:fixed;top:0;left:0;z-index:9998;;label:wrapperCss;"
};
exports.wrapperCss = wrapperCss;

var lightenDarkenColorToRGBA = function lightenDarkenColorToRGBA(col, amt, alpha) {
  var newCol = col;

  if (col[0] === '#') {
    newCol = col.slice(1);
  }

  var r = parseInt(newCol.slice(0, 2), 16) + amt;
  if (r > 255) r = 255;else if (r < 0) r = 0;
  var g = parseInt(newCol.slice(2, 4), 16) + amt;
  if (g > 255) g = 255;else if (g < 0) g = 0;
  var b = parseInt(newCol.slice(4, 6), 16) + amt;
  if (b > 255) b = 255;else if (b < 0) b = 0;

  if (!alpha) {
    return "rgb(".concat(r, ", ").concat(g, ", ").concat(b, ")");
  }

  return "rgba(".concat(r, ", ").concat(g, ", ").concat(b, ", ").concat(alpha, ")");
};

var getOverlayBackground = function getOverlayBackground(_ref) {
  var background = _ref.background,
      theme = _ref.theme;

  if (!background) {
    return 'transparent';
  }

  var primaryColor = theme && theme.getColor('foreground');
  var lightColor = primaryColor ? lightenDarkenColorToRGBA(primaryColor, 40, 0.85) : 'rgba(54, 77, 179, 0.85)';
  var darkColor = primaryColor ? lightenDarkenColorToRGBA(primaryColor, 0, 0.85) : 'rgba(64, 7, 108, 0.85)';
  return "linear-gradient(\n    -45deg,\n    ".concat(lightColor, ",\n    ").concat(darkColor, "\n  )");
};

var Overlay = (0, _styledBase["default"])("div", {
  target: "ekofeu00",
  label: "Overlay"
})("width:100%;height:100%;padding:0 8px;background:", getOverlayBackground, ";");
exports.Overlay = Overlay;
var innerCss = {
  name: "qfzgl-innerCss",
  styles: "width:100%;height:100%;position:relative;overflow:hidden;margin-bottom:100px;;label:innerCss;"
};
exports.innerCss = innerCss;
var innerWrapperCss = {
  name: "5rwk42-innerWrapperCss",
  styles: "width:100%;position:absolute;left:50%;@media screen and (max-width:580px){width:90%;};label:innerWrapperCss;"
};
exports.innerWrapperCss = innerWrapperCss;
var contentCss = {
  name: "nt51w1-contentCss",
  styles: "background-color:white;border-radius:10px;font-size:14px;color:#737689;box-shadow:1px 2px 5px 0 rgba(0,0,0,0.5);;label:contentCss;"
};
exports.contentCss = contentCss;
var sizes = {
  small: 375,
  medium: 535,
  mediumPlus: 620,
  large: 700
};
exports.sizes = sizes;

//# sourceMappingURL=Modal.styles.js.map